export const toHex = (N: number | null): string => {
  if (N === null) return "00";
  const num = parseInt(String(N));
  if (num === 0 || isNaN(num)) return "00";
  const clamped = Math.round(Math.max(0, Math.min(num, 255)));
  return "0123456789ABCDEF".charAt((clamped - clamped % 16) / 16) + "0123456789ABCDEF".charAt(clamped % 16);
};

export const RGBtoHex = (R: number, G: number, B: number): string => toHex(R) + toHex(G) + toHex(B);
